module.exports = __webpack_public_path__ + "img/ico-close.41aaf6d0.svg";